var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"iot-system-container"},[_c('el-main',{staticClass:"iot-system-main"},[_c('router-view')],1),_c('el-aside',{staticClass:"iot-system-aside public-scroll-transparent",style:(`background-color:${_vm.theme.SUBMENU_BACKGROUND_COLOR};`),attrs:{"width":"260px"}},[_c('help')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }